const headRowsInvitationsUsers = {
  email: 'E-mail',
  role: 'Tipo de Acceso',
  site: 'Sitio',
  createdAt: 'Enviado',
  invitation: 'Link',
};

export default headRowsInvitationsUsers;
